import kr from '../../kr/kr';
import HTMLClass from '../../kr/utils/HTMLClass';

export default class FormAddWWW extends kr.Component {
    init() {
        this.recaptchaInit = false;
        this.$ = window.jQuery;
        this.$form = this.$element.querySelector('form');
        this.$formStatus = this.$element.querySelector('.jsPriceFormStatus');
        this.messages = {
            success: this.$form.elements.success_message.value,
            error: this.$form.elements.error_message.value
        }
        this.action = this.$form.getAttribute('data-action');

        this.bind();
    }

    bind() {
        this.$form.addEventListener('submit', event => {
            event.preventDefault();
            this.hideError();
            this.showError('Dodaję...');
            this.ajax();
        });
    }

    async ajax() {
        this.hideError();
        this.showError('Wysyłam...');
        const formData = new FormData(this.$form);

        fetch(this.action, {
            method: 'POST',
            body: formData,
        }).then(response => {
            if(response.ok) {
                return response.json()
            }
            
            return response.json().then(response => {throw new Error(response.error + '<br>' + response.errors.join('<br>'))})
            
        }).then(response => {
            this.$form.reset();
            this.hideError();
            this.showError(this.messages.success);
        })
        .catch(err => {
            console.log(err);
            this.hideError();
            let error = this.messages.error;
            error += ' '+err;
            this.showError(error);
        });
    }

    showError(message) {
        const p = document.createElement('p');
        HTMLClass.addClass(p, 'message');
        p.id = "jsPriceFormMessage";
        p.innerHTML = message;

        this.$formStatus.appendChild(p);
    }

    hideError() {
        const p = document.getElementById('jsPriceFormMessage');
        if (!p) {
            return;
        }
        p.parentNode.removeChild(p)
    }
}

kr.registerComponent('.jsAddWWWForm', {
    component: FormAddWWW
});